const authorFromScratch = {
  topicId: "nualang.author-from-scratch.0.0.1",
  topicName: "从零开始的作者",
  description: "",
  difficulty: "ALL",
  learnLang: "chinese",
};

export default authorFromScratch;
